
import Nav from 'react-bootstrap/Nav';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { INavBarItem } from '../../../types/menu';

function NavItemComponent(props: INavBarItem,key: number) {
  return (

    <Nav.Item as="li" key={key}>
      <DropdownButton
        title={
          <>
            {props.title}

            {props.isIcon && <img src="/static/img/notification.png" alt="img" className="img-fluid" />}
          </>
        }

        variant="" data-bs-display="static" aria-expanded="false" as={ButtonGroup} >
        <div className="d-flex">
          {props.items1 && <div className="item">
            <ul>
              {props.items1?.map((item: INavBarItem) => (
                <li key={item.link} ><a href={item.link}  target={item.target?item.target:"_self"} className="dropdown-item"><img src="/static/img/arrow-left.png" alt={item.title} /> {item.title}</a></li>
              ))}</ul>
          </div>}
          {props.items2 && <div className="item">
            <ul>
              {props.items2?.map((item: INavBarItem) => (
                <li key={item.link}><a href={item.link} target={item.target?item.target:"_self"} className="dropdown-item"><img src="/static/img/arrow-left.png" alt={item.title} /> {item.title}</a></li>
              ))}</ul>
          </div>}
        </div>
      </DropdownButton>
    </Nav.Item>

  );
}

export default NavItemComponent;


